import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';

import { TyreDTO } from '../../../common/types/dto/TyreDTO';
import { config } from '../../common/';
import CardsResizer from '../../common/Components/CardsResizer';
import { useHistory } from '../../common/RouterHooks';
import cloudIcon from './assets/images/cloud_icon.svg';
import energyIcon from './assets/images/efficiency_icon.svg';
import tyreIcon from './assets/images/TyreLabelDefault.png';
import watterIcon from './assets/images/watter_icon.svg';

interface SimulatorResultsState {
    filteredTyreList: TyreDTO[];
    SelectedtyreIdList: number[];
}

interface SimulatorResultsProps {
    tyreList: TyreDTO[];
    filterOrdenacao: string;
    filterIC: string;
    filterCV: string;
    filterVersao: string;
    filterBrand: string;
}

const SimulatorResults: React.FC<SimulatorResultsProps> = (Props) => {
    const initialState: SimulatorResultsState = {
        filteredTyreList: [],
        SelectedtyreIdList: [],
    };
    const [state, setState]: [SimulatorResultsState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const history = useHistory();

    useEffect(() => {
        let filteredResult = Props.tyreList;
        if (Props.filterIC !== '') {
            filteredResult = filteredResult.filter((item) => item.ic === Props.filterIC);
        }
        if (Props.filterCV !== '') {
            filteredResult = filteredResult.filter((item) => item.cv === Props.filterCV);
        }
        if (Props.filterBrand !== '') {
            filteredResult = filteredResult.filter((item) => item.tyreBrandName === Props.filterBrand);
        }
        if (Props.filterVersao !== '') {
            filteredResult = filteredResult.filter((item) => item.versao === Props.filterVersao);
        }
        switch (Props.filterOrdenacao) {
            case 'M':
                filteredResult = filteredResult.sort((a, b) => (!a.description || !b.description) ? -1 : a.description.localeCompare(b.description));
                break;
            case 'P':
                filteredResult = filteredResult.sort((a, b) => (!a.centralSupplyListPrice || !b.centralSupplyListPrice) ? -1 : a.centralSupplyListPrice - b.centralSupplyListPrice);
                break;
            case 'B':
                filteredResult = filteredResult.sort((a, b) => (!a.tyreBrandName || !b.tyreBrandName) ? -1 : a.tyreBrandName.localeCompare(b.tyreBrandName));
                break;
            default:
        }
        setState({
            filteredTyreList: filteredResult,
            SelectedtyreIdList: [],
        });
    }, [Props.tyreList, Props.filterOrdenacao, Props.filterIC, Props.filterCV, Props.filterVersao, Props.filterBrand]);

    function OnCheckboxClick(tyreId: number) {
        if (state.SelectedtyreIdList.includes(tyreId)) {
            setState({
                SelectedtyreIdList: state.SelectedtyreIdList.filter((c) => c !== tyreId ),
            });
        } else {
            const tempList = state.SelectedtyreIdList;
            tempList.push(tyreId);
            setState({
                SelectedtyreIdList: tempList,
            });
        }
    }

    const BuildCard = (tyre: TyreDTO, id: number) => {
        return (
            <div className={classNames(['cell', 'medium-6', 'small-12', 'large-3'])}>
                <div key={'tyreres' + id} className={'tyre-container'}>
                    <div className={classNames(['tyre-header', state.SelectedtyreIdList.includes(tyre.tyreId) ? 'clicked' : ''])} onClick={() => OnCheckboxClick(tyre.tyreId)}>
                        <h3 className={'tyre-title'}>{tyre.description}</h3>
                        <input className={'tyre-checkbox'} type="checkbox" value={tyre.tyreId} checked={state.SelectedtyreIdList && state.SelectedtyreIdList.includes(tyre.tyreId)} />
                    </div>
                    <div className={'tyre-content-container'}>
                        <div className={'tyre-content-header'}>
                            <p className={'text-bold'}>{tyre.tyreBrandName}</p>
                            <div className={'icons'}>
                                <div className={'tyre-icon'}>
                                    <img src={watterIcon} alt="" />
                                    {tyre.fuelEfficiency}
                                </div>
                                <div className={'tyre-icon'}>
                                    <img src={cloudIcon} alt="" />
                                    {tyre.wetGrip}
                                </div>
                                <div className={'tyre-icon'}>
                                    <img src={energyIcon} alt="" />
                                    {tyre.exteriorNoiseRating && tyre.exteriorNoiseRating.replace(/\s/g, '')}
                                </div>
                            </div>
                        </div>
                        <div className={'tyre-content'}>
                            <div className={'tyre-content-cols'}>
                                <div>
                                    <p className={'tyre-little-title'}>Dimensōes</p>
                                    <p className={'tyre-medium-title'}>{tyre.tyreSpecKey}</p>
                                </div>
                                <div>
                                    <p className={'tyre-little-title'}>Preço</p>
                                    <p className={'tyre-medium-title'}>
                                        {tyre.centralSupplyListPrice ? (tyre.centralSupplyListPrice.toFixed(2) + '€**') : ''}</p>
                                </div>
                            </div>
                            <a href={tyre.labelCode ? config.EprelImageUrl.replace('{0}', tyre.labelCode) : tyreIcon} target="_blank">
                                <img style={{ height: 'auto', width: '75px' }} className={'clickable-img'} src={tyre.labelCode ? config.EprelImageUrl.replace('{0}', tyre.labelCode) : tyreIcon} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    function GoToContacto() {
        const selectedItems = state.filteredTyreList.filter((x) => state.SelectedtyreIdList.includes(x.tyreId));
        if (selectedItems.length > 0) {
            history.push(`${config.BaseURL}/tyre/contact/`, { tyreList: selectedItems });
        }
    }

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'fluid', 'margin-top-2'])}>
                <div className={classNames(['grid-x', 'grid-margin-x', 'grid-margin-y'])}>
                    {state.filteredTyreList.map((x, id) => {
                        return BuildCard(x, id);
                    })}
                </div>
            </div>
            <CardsResizer anchorClasses={['tyre-header', 'tyre-content-container']} triggers={[Props.tyreList, Props.filterOrdenacao, Props.filterIC, Props.filterCV, Props.filterVersao, Props.filterBrand]} />
            <div className={classNames(['tyres-footer', 'margin-top-2'])}>
                <p id="search-message" hidden={state.filteredTyreList.length === 0}>
                    Selecione um ou mais pneus.
                </p>
                <button className={classNames(['button', 'bttSubscrever'])} disabled={state.SelectedtyreIdList.length === 0} onClick={() => GoToContacto()} onSubmit={() => GoToContacto()}>
                    <span>Solicitar Contacto</span>
                </button>
                <p>
                    * Campos obrigatórios.
                </p>
                <p id="pvp-notification">
                    ** PVP unitário, não inclui (SGPU, Mão de Obra, Serviços, IVA e Outros Descontos).
                </p>
                <p style={{ maxWidth: '500px', textAlign: 'center' }}>
                    <br />
                    Em caso de etiqueta energética não disponível, ou para mais informações, por favor
                    consulte o endereço abaixo ou contacte o seu Ponto de Serviço Autorizado:
                    <br />
                    https://energy-efficient-products.ec.europa.eu/product-list/tyres_en
                </p>
            </div>
        </React.Fragment>
    );
};

export default SimulatorResults;
